import { createUseStyles } from 'react-jss'
import { colors } from '../../common/colors'

export const BORDER_WIDTH = 1
export const DATA_ROW_HEIGHT = 30
export const SPLIT_CHART_GAP = 12

export const style = {
  root: {
    display: 'flex'
  },
  splitChartContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    '& > *': {
      width: `calc(50% - ${SPLIT_CHART_GAP}px)`
    }
  },
  labelContainer: {
    flex: '0 0 auto',
    marginRight: 20
  },
  chartContainer: {
    flex: '1 1 auto'
  },
  labelText: {
    height: DATA_ROW_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    fontSize: 14
  },
  nullEffectLine: {
    stroke: colors.gray,
    strokeWidth: 1.5
  },
  svg: {
    display: 'block',
    overflow: 'visible'
  }
}

export const useStyles = createUseStyles(style)
